import getLocalString from "constants/Localization";
import { useUpdateOrganizationInvoiceEmailTextMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateOrganizationInvoiceEmailText() {
  const [mutation, { loading, data, error }] = useUpdateOrganizationInvoiceEmailTextMutation();

  const [updateOrganizationInvoiceEmailText, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateOrganizationInvoiceEmailText",
    },
    {
      successMessage: getLocalString("organization.update-invoice-email-text-success"),
      failureMessage: getLocalString("organization.update-invoice-email-text-failure"),
    }
  );

  return [updateOrganizationInvoiceEmailText, context] as const;
}
